import { render, staticRenderFns } from "./checkStudentHomework.vue?vue&type=template&id=4d15b4de&scoped=true"
import script from "./checkStudentHomework.vue?vue&type=script&lang=js"
export * from "./checkStudentHomework.vue?vue&type=script&lang=js"
import style0 from "./checkStudentHomework.vue?vue&type=style&index=0&id=4d15b4de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d15b4de",
  null
  
)

export default component.exports